import { withAppInsightsPublisher } from '@shared/lib/services/telemetry/application-insights/withAppInsightsPublisher';
import { provideTelemetry } from '@shared/lib/services/telemetry/provideTelemetry';
import { CaseManagementEnvironment } from './CaseManagementEnvironment';

export const environment: CaseManagementEnvironment = {
	providers: [
		provideTelemetry(
			withAppInsightsPublisher(
				// TODO: get app insights connection string.
				'00000000-0000-0000-0000-000000000000',
			),
		),
	],
	// translationEndPoint: 'https://tod.myportal.ul.com/languages/{0}',
	translationEndPoint:
		'https://casemanagement.myportal.ul.com/assets/i18n/{0}.json',
};
